(function ($) {
    "use strict";
    $(function () {
        if ($('.profile__datas').length === 0) {
            return;
        }




        $('.js-subscribe-to-mch').on('click', function (e) {
            e.preventDefault();

            var form = $('.js-subscribe');
            var data = grabFormAsObject(form);

            $.ajax({
                url: localize.ajaxurl,
                type: 'POST',
                data: {
                    action: "done_mch_subscribe",
                    data: data,
                },
                success: function (response) {
                    if (!response['fault']) {
                        $('#subscribe-status').html(localize.translations.subscribeStatus).removeClass('d-none');
                        $('.js-missing-subscribe-block').addClass("d-none");
                    }
                }
            });

        });
    });
})(jQuery);